import React, { createContext, useState, useEffect } from 'react';
import { supabase } from '../supabase';

export const AuthContext = createContext({
  userRole: null,
  setUserRole: () => {},
  isAuthenticated: false,
  setIsAuthenticated: () => {},
  logout: () => {},
});

const AuthProvider = ({ children }) => {
  const [userRole, setUserRole] = useState(localStorage.getItem('userRole') || null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkAuthState = async () => {
      const { data: { session } } = await supabase.auth.getSession();

      if (session) {
        setIsAuthenticated(true);

        let role = localStorage.getItem('userRole');
        let approved = false;

        if (!role) {
          const { data: userData, error: userError } = await supabase
            .from('users')
            .select('role, approved')
            .eq('id', session.user.id)
            .single();

          if (userError) {
            console.error('Error fetching user role:', userError.message);
            role = 'clientB'; // Default role
          } else {
            role = userData?.role || 'clientB';
            approved = userData?.approved || false;
          }

          localStorage.setItem('userRole', role); // ✅ Save role in localStorage
        }

        setUserRole(role);
      } else {
        setIsAuthenticated(false);
        setUserRole(null);
        localStorage.removeItem('userRole');
      }

      setLoading(false);
    };

    checkAuthState();

    const { data: authListener } = supabase.auth.onAuthStateChange((_event, session) => {
      setIsAuthenticated(!!session);
      if (!session) {
        setUserRole(null);
        localStorage.removeItem('userRole');
      }
    });

    return () => {
      authListener?.subscription?.unsubscribe();
    };
  }, []);

  const logout = async () => {
    await supabase.auth.signOut();
    setUserRole(null);
    setIsAuthenticated(false);
    localStorage.removeItem('userRole'); // ✅ Clear on logout
    window.location.href = '/login';
  };

  if (loading) {
    return <div style={{ textAlign: 'center', fontSize: '18px', marginTop: '50px' }}>Loading...</div>;
  }

  return (
    <AuthContext.Provider value={{ userRole, setUserRole, isAuthenticated, setIsAuthenticated, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthProvider;
